import { render, staticRenderFns } from "./modelWatchInfoRight.vue?vue&type=template&id=01d449de&scoped=true&"
import script from "./modelWatchInfoRight.vue?vue&type=script&lang=js&"
export * from "./modelWatchInfoRight.vue?vue&type=script&lang=js&"
import style0 from "./modelWatchInfoRight.vue?vue&type=style&index=0&id=01d449de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d449de",
  null
  
)

export default component.exports